"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var classnames_1 = __importDefault(require("classnames"));
var TreeNodeList_1 = require("./TreeNodeList");
var context_1 = require("./context");
var helpers_1 = require("./helpers");
var TreeSpacer_1 = require("./TreeSpacer");
var Tree = function (_a) {
    var _b = _a.canDrag, canDrag = _b === void 0 ? false : _b, canDrop = _a.canDrop, className = _a.className, data = _a.data, _c = _a.enableCheckboxes, enableCheckboxes = _c === void 0 ? false : _c, _d = _a.expandedByDefault, expandedByDefault = _d === void 0 ? false : _d, iconPosition = _a.iconPosition, iconSelector = _a.iconSelector, _e = _a.indicator, indicator = _e === void 0 ? false : _e, initialExpandedState = _a.initialExpandedState, onClick = _a.onClick, onMove = _a.onMove, onToggleCheckbox = _a.onToggleCheckbox, onToggleExpand = _a.onToggleExpand, checkedIds = _a.checkedIds, size = _a.size;
    var ref = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(initialExpandedState || {}), expandedState = _f[0], setExpandedState = _f[1];
    var flatIds = (0, react_1.useMemo)(function () {
        var flatten = function (nodes) {
            return nodes.reduce(function (acc, node) { return __spreadArray(__spreadArray(__spreadArray([], acc, true), [
                node
            ], false), (node.children ? flatten(node.children) : []), true); }, []);
        };
        return flatten(data).map(function (_a) {
            var id = _a.id;
            return id;
        });
    }, [data]);
    var focusFirst = (0, react_1.useCallback)(function () {
        var _a, _b, _c;
        if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.className.includes('tree-root')) && flatIds.length) {
            (_c = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.querySelector("[data-tree-item-id='".concat(flatIds[0], "']"))) === null || _c === void 0 ? void 0 : _c.focus();
        }
    }, [flatIds]);
    return ((0, jsx_runtime_1.jsx)(context_1.TreeContextProvider, __assign({ value: {
            canDrag: canDrag,
            canDrop: canDrop,
            onMove: onMove,
            size: size,
            enableCheckboxes: enableCheckboxes,
            checkedIds: checkedIds,
            onToggleCheckbox: onToggleCheckbox,
            iconPosition: iconPosition,
            iconSelector: iconSelector,
            expandedByDefault: expandedByDefault,
            expandedState: expandedState,
            setExpandedState: setExpandedState,
            onClick: onClick,
            onToggleExpand: onToggleExpand,
            flatIds: flatIds,
            indicator: indicator,
            ref: ref,
        } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('tree-root d-flex flex-column flex-grow-1', size === 'sm' && 'tree-sm', className), tabIndex: 0, ref: ref, onFocus: focusFirst, "data-testid": "tree-root" }, { children: (0, jsx_runtime_1.jsxs)(react_dnd_1.DndProvider, __assign({ manager: helpers_1.dndManager }, { children: [(0, jsx_runtime_1.jsx)(TreeNodeList_1.TreeNodeList, { nodes: data, level: 0, parentChecked: false }), (0, jsx_runtime_1.jsx)(TreeSpacer_1.TreeSpacer, { numItems: data.length })] })) })) })));
};
exports.Tree = Tree;
